import React from "react";
import "./FreeText.scss";
import { getTextColor } from "components/dashboard/charts/utils";
import { FreeTextConfig } from "./FreeTextConfig";

export default function FreeText(props: FreeTextConfig) {
  return (
    <div className="quill-rendered-content" style={{ height: `${props.height ?? "auto"}px` }}>
      <div
        style={{ color: getTextColor(props.theme) }}
        dangerouslySetInnerHTML={{
          __html: props.useHTMLCode ? (props.htmlContent ?? "") : (props.content ?? ""),
        }}
      />
    </div>
  );
}
